import * as React from "react";
import Header from "./header/header"
import Footer from "./footer/footer"

const Layout = ({ pageTitle, children }) => {
  return (
    <div className=" theme-dark bg-primary text-text-main min-h-screen">
      <div className="container mx-auto px-10 md:px-28">
          <Header/>
        <main>
          <h1 className="days-one font-bold mt-10 text-4xl ">{pageTitle}</h1>
          {children}
        </main>
      </div>
      <div className="sticky top-[100vh]">
          <Footer/>
        </div>
    </div>
  );
};

export default Layout;
